import { cx } from "@emotion/css";
import { CircularProgress } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import { useEffect, useRef, useState } from "react";
import { Animate } from "src/components/Default/Animate";
import { TextFieldGrey } from "src/components/Default/LekUI/TextField";
import { Tooltip } from "src/components/Default/LekUI/Tooltip";
import SearchIcon from "src/images/Icons/newIcons/search.svg";

interface IconTextFieldProps {
	tooltip: string;
	onSearch: (text: string) => void;
	isLoading?: boolean;
	onOpenClassName?: string;
	textFieldClassName?: string;
	placeholder?: string;
	open?: boolean;
}

export const IconTextField = ({
	tooltip,
	onSearch,
	isLoading,
	onOpenClassName,
	textFieldClassName,
	placeholder,
	open = false,
}: IconTextFieldProps) => {
	const [text, setText] = useState("");
	const [isOpen, setIsOpen] = useState(open);
	const ref = useRef<HTMLDivElement>(null);
	const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

	useEffect(() => {
		if (timeoutRef.current) clearTimeout(timeoutRef.current);
		timeoutRef.current = setTimeout(() => {
			onSearch(text);
		}, 500);
	}, [text, onSearch]);

	return (
		<div
			className={cx(
				"flex gap-8",
				onOpenClassName && {
					[onOpenClassName]: isOpen,
				},
			)}
		>
			<Animate
				isOpen={isOpen}
				timeout={200}
				className={textFieldClassName}
				animationClassName="swipe"
				nodeRef={ref}
			>
				<div ref={ref}>
					<TextFieldGrey
						autoFocus
						variant="outlined"
						margin="none"
						fullWidth
						placeholder={placeholder}
						size="small"
						className="input-with-triangle"
						onChange={(e) => setText(e.target.value)}
						value={text}
						slotProps={{
							input: {
								startAdornment: (
									<InputAdornment position="start" className="m-0">
										{isLoading && (
											<CircularProgress className="icon-small text-grey" />
										)}
										{!isLoading && (
											<SearchIcon className="icon-small icon-black-80" />
										)}
									</InputAdornment>
								),
							},
						}}
					/>
				</div>
			</Animate>
			<Tooltip title={tooltip}>
				<IconButton
					size="small"
					className="menu-icon-button square-32"
					onClick={() => setIsOpen(!isOpen)}
					disableRipple
				>
					<SearchIcon className="icon-small icon-black" />
				</IconButton>
			</Tooltip>
		</div>
	);
};
